import React, {Fragment, Component} from 'react';
import {withRouter} from 'react-router-dom';
import {withAITracking} from '@microsoft/applicationinsights-react-js';
import {ai} from "./TelemetryService";

// needs to be a class because '@microsoft/applicationinsights-react-js' requires a component
class InsightsProvider extends Component {
  state = {
    initialized: false
  };

  componentDidMount() {
    const {history} = this.props;
    const {initialized} = this.state;
    const AppInsightsInstrumentationKey = process.env.REACT_APP_INSIGHTS_KEY;

    if (!Boolean(initialized) && Boolean(AppInsightsInstrumentationKey) && Boolean(history)) {
      ai.initialize(AppInsightsInstrumentationKey, history);
      this.setState({initialized: true});
    }

    this.props.after();
  }

  render() {
    const {children} = this.props;
    return (
      <Fragment>
        {children}
      </Fragment>
    );
  }
}

export default withRouter(withAITracking(ai.reactPlugin, InsightsProvider));
